"use strict";

import angular from "angular";
import uiRouter from "angular-ui-router";
import diasLoading from "dias/core/loading";

import CoreModels from "dias/core/models";
import DiasErrors from "dias/core/errors";
import Auszahlungslisten from "./auszahlungslisten.service";

const modul = angular.module("dias.vertrag.cortexe.auszahlungslisten.models", [
  uiRouter,
  diasLoading.name,
  CoreModels.name,
  DiasErrors.name,
])

  .provider("Auszahlungslisten", Auszahlungslisten)
;

export default modul;
